import { createAction } from '@reduxjs/toolkit';

export const CHECKPUSH_ACTION_TYPE = 'saga/checkPush';
export const checkPushAction = createAction(CHECKPUSH_ACTION_TYPE);
